import NriForeignNationalsBanner from './NriForeignNationalsBanner';
import NriForeignNationalsSection from './NriForeignNationalsSection';

function NriForeignNationals() {
  return (
    <div>
      <NriForeignNationalsBanner />
      <NriForeignNationalsSection />
    </div>
  );
}

export default NriForeignNationals;